import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Challenges & Solutions</h2>
            <p>
              Understanding and leveraging existing features while gradually
              implementing new solutions and maintaining the essence of the
              platform was complicated but with a clear-cut strategy toward
              product development and our °360 approach supporting value-driven
              change, the transition was quick.
            </p>
            <p>
              Our focus was gathered around making sure the cultural nuances
              attached to our client were intact and in the limelight. We
              highlighted how Al Hussaini Trading Company has evolved since 1975
              and has set a benchmark for itself today through an intuitive
              design, UX, and clarified branding.
            </p>
            <p>
              From an eCommerce standpoint, we looked over POS integration, CRM
              system, and how ERP (Enterprise Resource Planning) takes place.
              The BigCommerce alternative we proposed and implemented includes
              plugins that are integral to the customer experience.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/alhussaini/tek-img_02.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={372}
              height={663}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
